import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';
import Spinner from '../components/Spinner.jsx';

/**
 * Route guard. `roles` restricts a whole branch of the router; the API enforces
 * the same rules again - the client guard is only there for the UX.
 */
const ProtectedRoute = ({ roles }) => {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <Spinner full />;
  if (status !== 'authenticated') return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/403" replace />;

  return <Outlet />;
};

export default ProtectedRoute;
